import { ICurrencyResp } from '@monetize/types/app';
import {
  ALL_CURRENCIES,
  CurrencyCodes,
  SUPPORTED_CURRENCIES,
} from '@monetize/types/common';
import { formatCurrency } from '@monetize/utils/core';

/** A whole number, so zero-decimal currencies (CLP, ISK) don't render a fractional sample. */
const SAMPLE_AMOUNT = 12345;

export const getCurrencyName = (code: CurrencyCodes) =>
  ALL_CURRENCIES[code]?.name ?? code;

export const getCurrencySample = (code: CurrencyCodes) =>
  formatCurrency(SAMPLE_AMOUNT, { currency: code });

/** Supported currencies the tenant has not enabled yet, sorted by code. */
export const getAvailableCurrencyCodes = (
  enabledCurrencies: Pick<ICurrencyResp, 'code'>[],
): CurrencyCodes[] => {
  const enabledCodes = new Set(enabledCurrencies.map(({ code }) => code));
  return (Object.keys(SUPPORTED_CURRENCIES) as CurrencyCodes[])
    .filter((code) => !enabledCodes.has(code))
    .sort();
};

/** Case-insensitive match against the currency code or its name. */
export const matchesCurrencySearch = (
  code: CurrencyCodes,
  searchTerm: string,
) => {
  const normalizedTerm = searchTerm.trim().toLowerCase();
  if (!normalizedTerm) {
    return true;
  }
  return (
    code.toLowerCase().includes(normalizedTerm) ||
    getCurrencyName(code).toLowerCase().includes(normalizedTerm)
  );
};
